import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgIconMinus = (props, ref) => _jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", ref: ref, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M6 12a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1", clipRule: "evenodd" }) });
const ForwardRef = forwardRef(SvgIconMinus);
export default ForwardRef;
